import { Capacitor } from "@capacitor/core";

interface ServiceWorkerEnvironment {
  production: boolean;
  nativePlatform: boolean;
  serviceWorkerAvailable: boolean;
  protocol: string;
  hostname: string;
}

export function shouldRegisterOfflineApp(environment: ServiceWorkerEnvironment): boolean {
  const secureOrigin =
    environment.protocol === "https:" ||
    environment.hostname === "localhost" ||
    environment.hostname === "127.0.0.1";
  return (
    environment.production &&
    !environment.nativePlatform &&
    environment.serviceWorkerAvailable &&
    secureOrigin
  );
}

export function registerOfflineApp(): void {
  if (
    !shouldRegisterOfflineApp({
      production: import.meta.env.PROD,
      nativePlatform: Capacitor.isNativePlatform(),
      serviceWorkerAvailable: "serviceWorker" in navigator,
      protocol: window.location.protocol,
      hostname: window.location.hostname,
    })
  ) {
    return;
  }

  const register = () => {
    void navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => undefined);
  };
  if (document.readyState === "complete") {
    register();
  } else {
    window.addEventListener("load", register, { once: true });
  }
}
